'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = function (ComposedComponent) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    (0, _inherits3.default)(WithRoles, _React$Component);

    function WithRoles() {
      (0, _classCallCheck3.default)(this, WithRoles);
      return (0, _possibleConstructorReturn3.default)(this, (WithRoles.__proto__ || Object.getPrototypeOf(WithRoles)).apply(this, arguments));
    }

    (0, _createClass3.default)(WithRoles, [{
      key: 'redirect',
      value: function redirect() {
        this.context.router.replace({
          pathname: '/login',
          state: { nextPathname: window.location.pathname }
        });
        return _react2.default.createElement('span', null);
      }
    }, {
      key: 'render',
      value: function render() {
        var me = this.context.me;
        if (!me) return this.redirect();
        return _react2.default.createElement(ComposedComponent, this.props);
      }
    }]);
    return WithRoles;
  }(_react2.default.Component), _class.contextTypes = {
    me: _propTypes2.default.object,
    router: _propTypes2.default.object
  }, _temp;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/decorators/forceLogin.js
// module id = 2552
// module chunks = 0